import { render, staticRenderFns } from "./NoAvailableHostingView.vue?vue&type=template&id=b8e0f414"
import script from "./NoAvailableHostingView.vue?vue&type=script&lang=js"
export * from "./NoAvailableHostingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports